import { render, staticRenderFns } from "./CustomOutro.vue?vue&type=template&id=c2e2d9ac&scoped=true&"
import script from "./CustomOutro.vue?vue&type=script&lang=ts&"
export * from "./CustomOutro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e2d9ac",
  null
  
)

export default component.exports